<!-- Breadcrumb -->
<div class="row" *ngIf="Breadcrumb != null">
  <div class="col-12 border-bottom headersize">
    <app-breadcrumb [Breadcrumb]="Breadcrumb"></app-breadcrumb>
  </div>
</div>

<!-- Study Unit Header -->
<div class="row">
  <div class="col-12 px-3 py-2" [style.background-color]="headingBgColor">
    <div class="d-flex align-items-center justify-content-between">
      <div class="fw-bold" style="font-size: 0.95rem; letter-spacing: 0.01rem;">{{ headingLabel }}: {{ StudyUnit.Name }}</div>
      <button
        *ngIf="showHeaderCloseButton"
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="ClosePopup()"
      ></button>
    </div>
  </div>
</div>

<!-- Table Display -->
<div class="row pt-2 px-3">
  <div class="col-12">
    <div class="scroll-style">
      <table class="table table-sm">
        <thead>
          <tr>
            <th class="text-center fw-medium border-0" style="width: 5%">No.</th>
            <th class="text-center fw-medium border-0" style="width: 10%">StudyUnit ID</th>
            <th class="text-center fw-medium border-0" style="width: 10%">Subject ID</th>
            <th class="text-center fw-medium border-0" style="width: 55%">Subject Name</th>
            <th class="text-center fw-medium border-0" style="width: 20%">Test Probability Name</th>
          </tr>
        </thead>
        <tbody cdkDropList (cdkDropListDropped)="drop($event)" class="example-list">
          <tr *ngFor="let s of studyunitlist; let i = index" cdkDrag class="example-box">
            <td class="border-bottom-0">
              <div class="custom-input text-center">{{ i + 1 }}</div>
            </td>
            <td class="border-bottom-0">
              <div class="custom-input text-center">{{ s.Study_Unit_ID }}</div>
            </td>
            <td class="border-bottom-0">
              <div class="custom-input text-center">{{ s.Subject_ID }}</div>
            </td>
            <td class="border-bottom-0">
              <div class="custom-input text-start">{{ s.Subject_Name }}</div>
            </td>
            <td class="border-bottom-0">
              <div class="custom-input text-start">{{ s.Testing_Probability_Type_Name ?? '' }}</div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- No Data -->
      <div class="text-center py-3" *ngIf="!studyunitlist?.length">
        No search results
      </div>


    </div>
  </div>
</div>

<!-- Footer Button -->
<div
  class="d-flex justify-content-end gap-2 px-3 py-2 position-sticky bottom-0 bg-white border-top"
  style="z-index: 2"
>
  <button type="button" class="btn btn-sm bg-light border" (click)="ClosePopup()">Close</button>
  <button type="button" class="btn btn-sm bl-btn border" (click)="Save()">Save</button>
</div>
